import React from "react";
import toSlug from "../../util/Slug";
import Key from "../../util/Key";
import switchValidation from "../../validation/swtichValidation";
import swtichOnChange from "../../validation/swtichOnChange";
import { FcAddressBook } from "react-icons/fc";

const Input = ({
    input,
    register,
    errors,
    where = "preview",
    color = "212529",
    background = "#fff",
    // border = "1px solid #ced4da",
    inline,
    showlabel,
}) => {
    const slugData = toSlug(input.label);

    const labelStyles = {
        color: "#" + color,
    };

    const inputStyle = {
        backgroundColor: background,
        // border: border,
        color: "#" + color,
    };

    const colums = () => {
        if (where == "form") {
            if (inline != false) {
                return inline;
            } else {
                if (input.size == "0") {
                    return "col-sm-6 col-12 mb-3";
                } else {
                    return "col-12 mb-3";
                }
            }
        } else {
            return "";
        }
    };
    return (
        <div key={Key()} className={colums()}>
            <div className="contiene-input">
                {showlabel == true && (
                    <label style={labelStyles} className="form-label">
                        {input.label}{" "}
                        {where == "preview" && input.reply_to == 1 && (
                            <FcAddressBook />
                        )}
                    </label>
                )}

                <input
                    style={inputStyle}
                    key={Key()}
                    name={input.label && slugData}
                    type={where === "form" ? input.input.type : "undefined"}
                    className={`input-border form-control orm-control-material
          ${errors[slugData] ? "is-invalid" : ""}`}
                    placeholder={input.placeholder}
                    {...register(slugData, {
                        required:
                            input.required === "1"
                                ? input.error_message
                                : false,
                        validate: switchValidation(
                            input.required === "1"
                                ? input.input.validation_type
                                : false
                        ),
                    })}
                    onChange={
                        where === "form" &&
                        input.input.validation_type === "rut"
                            ? swtichOnChange()
                            : undefined
                    }
                />

                {input.required === "1" && errors[slugData] ? (
                    <div className="invalid-feedback">
                        {errors[slugData].message}
                    </div>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
};

export default Input;
